"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var validate_js_1 = require("validate.js");
function findErrors(json_data, rules) {
    var r = validate_js_1.validate(json_data, rules);
    if (!r) {
        return { isValid: true, errors: {} };
    }
    if (r.hasOwnProperty("ssn")) {
        r.ssn[0] = ["SSN can't be blank"];
    }
    var r2 = __assign({}, r);
    for (var key in r2) {
        r2[key] = r2[key][0];
    }
    return { isValid: false, errors: r2 };
}
exports.findErrors = findErrors;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmluZEVycm9ycy5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2xpYi9mdW5jdGlvbnMvZmluZEVycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQW9DO0FBRXBDLFNBQWdCLFVBQVUsQ0FDdEIsU0FBUyxFQUNULEtBQUs7SUFFTCxJQUFJLENBQUMsR0FBRyxzQkFBUSxDQUFDLFNBQVMsRUFBRSxLQUFLLENBQUMsQ0FBQTtJQUVsQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1FBQ0osT0FBTyxFQUFDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLEVBQUUsRUFBQyxDQUFBO0tBQ3JDO0lBQ0QsSUFBSSxDQUFDLENBQUMsY0FBYyxDQUFDLEtBQUssQ0FBQyxFQUFFO1FBQ3pCLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxvQkFBb0IsQ0FBQyxDQUFBO0tBQ3BDO0lBQ0QsSUFBSSxFQUFFLGdCQUFPLENBQUMsQ0FBQyxDQUFBO0lBQ2YsS0FBSyxJQUFJLEdBQUcsSUFBSSxFQUFFLEVBQUU7UUFDaEIsRUFBRSxDQUFDLEdBQUcsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtLQUN2QjtJQUNELE9BQU8sRUFBQyxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxFQUFFLEVBQUMsQ0FBQTtBQUN2QyxDQUFDO0FBakJELGdDQWlCQyJ9